export const ROLE_TYPE = {
  REVIEWER: "REVIEWER",
};
